import MuiTable, { type TableProps as MuiTableProps } from '@mui/material/Table'
import MuiTableContainer, { type TableContainerProps as MuiTableContainerProps } from '@mui/material/TableContainer'
import MuiTableHead, { type TableHeadProps as MuiTableHeadProps } from '@mui/material/TableHead'
import MuiTableBody, { type TableBodyProps as MuiTableBodyProps } from '@mui/material/TableBody'
import MuiTableRow, { type TableRowProps as MuiTableRowProps } from '@mui/material/TableRow'
import MuiTableCell, {
  type TableCellProps as MuiTableCellProps,
  tableCellClasses as MuiTableCellClasses,
} from '@mui/material/TableCell'

//* BASE TABLE
export const BaseTable = MuiTable
export type TableProps = MuiTableProps

//* TABLE CONTAINER
export const BaseTableContainer = MuiTableContainer
export type TableContainerProps = MuiTableContainerProps

//* TABLE HEAD
export const BaseTableHead = MuiTableHead
export type TableHeadProps = MuiTableHeadProps

//* TABLE BODY
export const BaseTableBody = MuiTableBody
export type TableBodyProps = MuiTableBodyProps

//* TABLE ROW
export const BaseTableRow = MuiTableRow
export type TableRowProps = MuiTableRowProps

//* TABLE CELL
export const BaseTableCell = MuiTableCell
export const tableCellClasses = MuiTableCellClasses
export type TableCellProps = MuiTableCellProps
